import { gql } from '@apollo/client'

export const GET_ALL_ORDERS = gql`
  query getAllOrders($search: String, $limit: Int, $offset: Int, $storeId: [String], $filters: OrderFiltersInput) {
     orderListQuery(search: $search, limit: $limit, offset: $offset, storeId: $storeId, filters: $filters) {
      limit
      offset
      totalPages
      totalRecords
        rows{
            orderId
            orderNumber
            customer{
                name
                firstName
                lastName
                phoneNumber
            }
            address{
             phone
            }
            orderDate
            service
            total
            paymentMode
            paymentStatus
            orderStatus
            store{
                name{
                ar
                en
                }
                outletCode
                address{
                  city{
                    ar 
                    en
                  }
                }
            }
            meta{
                config{
                    currency{
                        currency
                        currencyCode
                    }
                    country{
                      timezone
                    }
                }
            }
            dispute
        }
    }
  }
`;
export const GET_ORDER_DETAILS = gql`
    query getOrder($id: String, $storeId: [String]) {
        orderQuery(id: $id, storeId: $storeId) {
           id
    service
    scheduleTime
    orderId
    orderToken
    onlinePayable
    orderNumber
    createdAt
    outletCode
    expectText {
      ar
      en
    }
    store {
      name {
        ar
        en
      }
      address {
        address {
          ar
          en
        }
      }
    }
    address {
      name
      phoneCode
      phone
      houseNumber
      apartment
      direction
      addressType
      formatted
      geoData {
        coordinates {
          lat
          lng
        }
      }
    }
    user {
      id
      firstName
      firstName
      email
      phoneCode
      phoneNumber
      userType
    }
    meta {
      config {
        currency {
          currencyCode
        }
        country{
          timezone
        }
        biteCoinConfig {
          coinValue
          minCoin
        }
        taxConfig {
          gst
          vat
          taxType
          isInclusive
          tin
        }
      }
    }
    orderStatus
    paymentStatus
    lang
    remarks
    loyaltyPoints {
      earnedCoins {
        coin
        value
      }
      usedCoins {
        coin
        value
      }
    }
    count
    subtotal
    deliveryCharge
    dineinCharge
    takeawayCharge
    discountedPrice
    total
    taxTotal
    itemTotal
    paymentMode
    customerCareNumber
    products {
      id
      itemId
      remark
      product {
        name {
          ar
          en
        }
        image
        defaultSalesPrice
        price
        storesPrice {
          prices {
            DELIVERY
            TAKEAWAY
            GLOBAL_DELIVERY
            GLOBAL_TAKEAWAY
          }
        }
        description {
          ar
          en
        }
      }
      remark
      quantity
      unitPrice
      amount
      modifierGroups {
        id
        groupName {
          ar
          en
        }
        type
        modifiers {
          id
          quantity
          unitPrice
          amount
          modifier {
            modItemName {
              en
              ar
            }
            image
            foodType
          }
        }
      }
    }
    walletUsed
    promocode {
      id
      code
    }
    walletTransactionId
    paymentId
    walletMeta {
      card {
        cardNumber
        cardUuid
      }
    }
    }
}`;